module.exports = __webpack_public_path__ + "static/media/10_hero_desktop.a60204bf.jpg";